import { en } from './en';
import { ru } from './ru';
import { bg } from './bg';

export const translations = {
  en,
  ru,
  bg
};
